import { useState } from 'react';
import { refresh_token } from '../main_components/tokens/tokenrefresh';
import "./style.css";
import NetworkCellIcon from '@mui/icons-material/NetworkCell';
import { BREADCRUMBS } from '../main_components/pagination/breadcrumbs';
import { test_red_get } from '../services/supports/avisos';

export const RED_TEST = () => {
    const [metrics, setMetrics] = useState([]);
    const [timingMetrics, setTimingMetrics] = useState([]);
    const [load, setload] = useState(false);
    const [type, settype] = useState(1);
    const [progress, setProgress] = useState(0);
    const [message, setMessage] = useState('Iniciando...');
  
    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const measurePerformance = async () => {
      try {
        const rf = await refresh_token();
        if (rf) {

          setload(true);
          setProgress(10);
          setMessage("Analizando Red...");
          await sleep(1000);

          performance.clearResourceTimings();

          setProgress(30);
          setMessage("Realizando Petición...")
          await sleep(1000);        
          
          const response = await test_red_get(type); 
          const data = await response.text();
          await new Promise(resolve => setTimeout(resolve, 100));
      
          const entries = performance.getEntriesByType("resource");
          
          console.log(entries)

          const entry = entries.find(e =>
            e.initiatorType === 'fetch'
          );
          if (!entry) {
            console.warn("No se encontró la entrada de rendimiento para el recurso.");
            setload(false);
            return;
          }
          setProgress(70);
          setMessage("Capturando Información...")
          await sleep(500);    

          // Calcular métricas desde entry
          const queueTime = (entry.fetchStart - entry.startTime).toFixed(2);
          const connectionTime = (entry.connectEnd - entry.connectStart).toFixed(2);
          const ttfb = (entry.responseStart - entry.requestStart).toFixed(2);
          const downloadTime = (entry.responseEnd - entry.responseStart).toFixed(2);
          const totalTime = (entry.responseEnd - entry.startTime).toFixed(2);

          const compressedSize = entry.encodedBodySize;
          const uncompressedSize = entry.decodedBodySize;
          const transferSize = entry.transferSize;

          const downloadTimeSec = (entry.responseEnd - entry.responseStart) / 1000;
          const speedKbps = downloadTimeSec > 0
            ? ((compressedSize / 1024) / downloadTimeSec).toFixed(2)
            : 'N/A';
          const speedMbps = downloadTimeSec > 0
            ? ((compressedSize / (1024 * 1024)) / downloadTimeSec).toFixed(2)
            : 'N/A';
          
          setMetrics({
            codigoEstado: response.status,
            tiempoEnCola: Number(queueTime),
            inicioConexion: Number(connectionTime),
            primerByte: Number(ttfb),
            tiempoDescarga: Number(downloadTime),
            tiempoTotal: Number(totalTime),
            tamanoTransferido: Number((transferSize / (1024 * 1024)).toFixed(4)),
            tamanoComprimido: Number((compressedSize / (1024 * 1024)).toFixed(4)),
            tamanoSinComprimir: Number((uncompressedSize / (1024 * 1024)).toFixed(4)),
            velocidadRed: speedKbps,
            velocidadRedMb: speedMbps,
          });
        
          // Si deseas incluir métricas de navegación
          const [navigationEntry] = performance.getEntriesByType('navigation');
          console.log(navigationEntry)
          if (navigationEntry) {
            const translatedTiming = {
              'Inicio_de_navegacion': `${navigationEntry.startTime.toFixed(4)} ms`, //Es el momento en que el usuario carga o navega hacia tu página (inicio absoluto del proceso).
              'Inicio_de_fetch': `${navigationEntry.fetchStart.toFixed(4)} ms`, //el navegador comienza a buscar recursos como tu API o archivos externos.
              'Inicio_busqueda_DNS': `${navigationEntry.domainLookupStart.toFixed(4)} ms`, //El navegador resuelve el nombre del dominio para obtener su dirección IP.si inicio y fin son iguales, usó caché.
              'Fin_busqueda_DNS': `${navigationEntry.domainLookupEnd.toFixed(4)} ms`, 
              'Inicio_de_conexión': `${navigationEntry.connectStart.toFixed(4)} ms`, //Se abre la conexión con el servidor (probablemente incluye el "handshake" TLS).
              'Fin_de_conexión': `${navigationEntry.connectEnd.toFixed(4)} ms`,
              'Inicio_solicitud': `${navigationEntry.requestStart.toFixed(4)} ms`, //El navegador envió la solicitud HTTP al servidor justo después de abrir la conexión.
              'Fin_de_respuesta': `${navigationEntry.responseEnd.toFixed(4)} ms`, //Toda la respuesta fue descargada.
              'DOM_interactivo': `${navigationEntry.domInteractive.toFixed(4)} ms`, //El navegador terminó de analizar el HTML y ahora el usuario ya puede empezar a interactuar con la página (aunque aún faltan scripts o imágenes).
              //'Inicio DOMContentLoaded': `${navigationEntry.domContentLoadedEventStart.toFixed(2)} ms`, //Todos los elementos HTML fueron procesados, y los scripts que están en el <head> también. Este evento es clave para saber que la página terminó de cargar su estructura.
              //'Fin DOMContentLoaded': `${navigationEntry.domContentLoadedEventEnd.toFixed(2)} ms`,
              'DOM_completo': `${navigationEntry.domComplete.toFixed(4)} ms`, //El navegador terminó de construir completamente la página, incluyendo todos los scripts y recursos.
              'Carga_total_de_página': `${navigationEntry.loadEventEnd.toFixed(4)} ms`, //Aquí la página terminó de cargar completamente, incluyendo imágenes, estilos, scripts externos, etc.
            };
      
            setTimingMetrics(translatedTiming);
          }

          setProgress(100);
          setMessage("Terminando Proceso...")
          await sleep(1000);    
          setload(false);
          setProgress(0);

          console.log(metrics)
          console.log(timingMetrics)

        }
        }catch (error) {
          console.log(error);
          setload(false);
          setMetrics([]);
          setTimingMetrics([]);
        }
    };


    
    return (  
      <>
        <BREADCRUMBS niveles={
          [
            { label: "SALUD DE RED", path: null },
          ]
        }
      cards_dashboard={false}    
  ></BREADCRUMBS>
   <div className="content-test-red-od2">
           
           {/* <h2 className='title-module-redtest'>SALUD DE RED</h2>
           <p className='test-module-redtest'>Monitoreo de rendimiento y diagnóstico de la conexión de red</p> */}
           <div className='section-testred-buttons-actions'>
             <div className='section-testred-buttons-grid'>
               <button 
                 className={type===1 ?'sectbg1':'sectbg2'}
                 onClick={()=>settype(1)}  
               >
                 Prueba Ligera
               </button>
               <button 
                 className={type===2 ?'sectbg1':'sectbg2'}
                 onClick={()=>settype(2)}
               >
                 Prueba Robusta
               </button>
             </div>
             <div className='section-testred-buttons-action-search'>
               <button 
                 disabled={load}
                 onClick={()=>measurePerformance()}
               ><NetworkCellIcon></NetworkCellIcon> Ejecutar prueba de red 
               </button>
             </div>
           </div>
         {
           load === false ?
           <>
           <div className='sections-panels-red-a'>
               <div className='panel-a-status-red'>
                 <div className='sections-panels-red-a-title'>
                     {/* <NetworkWifiIcon></NetworkWifiIcon> */}
                     <h2>Estado de Conexión</h2>
                 </div>
                 <p className='info-text'>Información básica de la conexión</p>
                 <div className='panel-a-status-stadistics'>
                     <div className='panel-a-status-stadistics-a'>
                       <p className='st1'>Código HTTP</p>
                       <p className={
                          metrics?.codigoEstado === 200 ? 'st2':
                          metrics?.codigoEstado === 500 || metrics?.codigoEstado === 502?'sterror':'stdefault'
                        }
                      >{metrics?.codigoEstado ? metrics?.codigoEstado : "" }</p>
                     </div>
                     <div className='panel-a-status-stadistics-b'>
                       <div className='panel-key-value-data'>
                         <p className='st1'>Tiempo de respuesta del servidor (TTFB)</p>
                         <p className='st2'>{metrics?.primerByte ? metrics?.primerByte : "0"} ms</p>
                       </div>
                       {
                        metrics?.primerByte >= 0 && metrics?.primerByte <= 800 ? 
                          <div className='line-progress-green-test'></div>:
                        metrics?.primerByte > 800  && metrics?.primerByte <= 2000 ?
                          <div className='line-progress-yellow-test'></div>:
                        metrics?.primerByte > 2000 ?
                          <div className='line-progress-red-test'></div>:
                          <div className='line-progress-gray-test'></div>
                       }
                     </div>
                     <div className='panel-a-status-stadistics-b'>
                       <div className='panel-key-value-data'>
                         <p className='st1'>Tiempo de descarga</p>
                         <p className='st2'>{metrics?.tiempoDescarga ? metrics?.tiempoDescarga : "0"} ms</p>
                       </div>
                       {
                        metrics?.tiempoDescarga >= 0 && metrics?.tiempoDescarga <= 100 ? 
                          <div className='line-progress-green-test'></div>:
                        metrics?.tiempoDescarga > 100  && metrics?.tiempoDescarga <= 500 ?
                          <div className='line-progress-yellow-test'></div>:
                        metrics?.tiempoDescarga > 500 ?
                          <div className='line-progress-red-test'></div>:
                          <div className='line-progress-gray-test'></div>
                       }
                     </div>
                   <div/>
               </div>
             </div>
             <div className='panel-a-status-speed'>
               <div className='sections-panels-speed-title'>
                 <h2>Velocidad Wifi y Tamaño</h2>
                 <p>Métricas de transferencia de datos</p>
               </div>
               <div className='sections-panels-red-resource'>
                 <p className='sections-panels-red-resouce-kb'>
                     {metrics?.velocidadRed ? metrics?.velocidadRed : 0 } KB/s
                 </p>
                 <p className='sections-panels-red-resouce-mb'>{metrics?.velocidadRedMb ? metrics?.velocidadRedMb : 0} MB/s</p>
               </div>
               <div className='sections-panels-red-resource-uploaddown'>
                 <div className='sec-res-uploaddown-a'>
                     <p>Tamaño transferido</p>
                     <h2>{metrics?.tamanoTransferido ? metrics?.tamanoTransferido : 0} MB</h2>
                 </div>
                 <div className='sec-res-uploaddown-b'>
                     <p>Tamaño de respuesta</p>
                     <h2>{metrics?.tamanoSinComprimir ? metrics?.tamanoSinComprimir : 0} MB</h2>
                 </div>
               </div>
             </div>
               
           </div>
           <div className='sections-panels-times'>
             <div className='sections-panels-times-title'>
               <h2>Tiempos de Solicitud</h2>
               <p>Desglose de tiempos de la solicitud de red</p>
             </div>
             <div className='sections-panels-red-time-grid'>
               <div className='sections-redtime-gr1'>
                 <h2>Tiempos en cola</h2>
                 <p>{metrics?.tiempoEnCola ? metrics?.tiempoEnCola : 0 } ms</p>
                 {
                  metrics?.tiempoEnCola >=0 && metrics?.tiempoEnCola <= 50 ?
                    <div className='line-green-testred'></div>:
                  metrics?.tiempoEnCola >50 && metrics?.tiempoEnCola <= 200 ?
                    <div className='ine-yellow-testred'></div>:
                  metrics?.tiempoEnCola >200?
                    <div className='line-red-testred'></div>:
                    <div className='line-gray-testred'></div>        
                 }
               </div>
               <div className='sections-redtime-gr2'>
                 <h2>Inicio de conexión</h2>
                 <p>{metrics?.inicioConexion ? metrics?.inicioConexion : 0} ms</p>
                  {
                    metrics?.inicioConexion >=0 && metrics?.inicioConexion <= 100 ?
                      <div className='line-green-testred'></div>:
                    metrics?.inicioConexion >100 && metrics?.inicioConexion <= 300 ?
                      <div className='ine-yellow-testred'></div>:
                    metrics?.inicioConexion >300?
                      <div className='line-red-testred'></div>:
                      <div className='line-gray-testred'></div>        
                  }
               </div>
               <div className='sections-redtime-gr3'>
                 <h2>Tiempo total</h2>
                 <p>{metrics?.tiempoTotal ? metrics?.tiempoTotal : 0} ms</p>
                 {
                  metrics?.tiempoTotal >=0 && metrics?.tiempoTotal <= 1000 ?
                    <div className='line-green-testred'></div>:
                  metrics?.tiempoTotal >1000 && metrics?.tiempoTotal <= 2000 ?
                    <div className='line-yellow-testred'></div>:
                  metrics?.tiempoTotal >2000?
                    <div className='line-red-testred'></div>:
                    <div className='line-gray-testred'></div>   
                 }
               </div>
             </div>
 
           </div>
           <div className='sections-panels-performance'>
             <div className='sections-panels-performance-title'>
               <h2>Valores de Performance</h2>
               <p>Métricas detalldas de rendimiento de cargas</p>
             </div>
               <h2 className='title-sections-cards-times'>Tiempos de Navegación</h2>
               <div className='sections-panels-perf-grid'>
                 <div className='sect-pan-perfitem1'>
                   <p>Inicio de navegación</p>
                   <p className='sect-pan-perfitemstrong'>{timingMetrics?.Inicio_de_navegacion ? timingMetrics?.Inicio_de_navegacion : 0 }</p>
                 </div>
                 <div className='sect-pan-perfitem2'>
                   <p>Inicio de Fetch</p>
                   <p className='sect-pan-perfitemstrong'>{timingMetrics?.Inicio_de_fetch ? timingMetrics?.Inicio_de_fetch : 0}</p>
                 </div>
                 <div className='sect-pan-perfitem3'>
                   <p>Inicio de búsqueda DNS</p>
                   <p className='sect-pan-perfitemstrong'>{timingMetrics?.Inicio_busqueda_DNS ? timingMetrics?.Inicio_busqueda_DNS : 0}</p>
                 </div>
               </div>
               <br></br>
               <h2 className='title-sections-cards-times'>Tiempos de Conexión</h2>
               <div className='sections-panels-perf-grid'>
                 <div className='sect-pan-perfitem1'>
                   <p>Fin búsqueda DNS</p>
                   <p className='sect-pan-perfitemstrong'>{timingMetrics?.Fin_busqueda_DNS ? timingMetrics?.Fin_busqueda_DNS : 0 }</p>
                 </div>
                 <div className='sect-pan-perfitem2'>
                   <p>Inicio de Conexión</p>
                   <p className='sect-pan-perfitemstrong'>{timingMetrics?.Inicio_de_conexión ? timingMetrics?.Inicio_de_conexión : 0}</p>
                 </div>
                 <div className='sect-pan-perfitem3'>
                   <p>Fin de Conexión</p>
                   <p className='sect-pan-perfitemstrong'>{timingMetrics?.Fin_de_conexión ? timingMetrics?.Fin_de_conexión : 0}</p>
                 </div>
               </div>
               <br></br>
               <h2 className='title-sections-cards-times'>Tiempos de carga</h2>
               <div className='sections-panels-perf-grid'>
                 <div className='sect-pan-perfitem1'>
                   <p>Inicio Solicitud</p>
                   <p className='sect-pan-perfitemstrong'>{timingMetrics?.Inicio_solicitud ? timingMetrics?.Inicio_solicitud : 0 }</p>
                 </div>
                 <div className='sect-pan-perfitem2'>
                   <p>Fin de Respuesta</p>
                   <p className='sect-pan-perfitemstrong'>{timingMetrics?.Fin_de_respuesta ? timingMetrics?.Fin_de_respuesta : 0}</p>
                 </div>
                 <div className='sect-pan-perfitem3'>
                   <p>DOM interactivo</p>
                   <p className='sect-pan-perfitemstrong'>{timingMetrics?.DOM_interactivo ? timingMetrics?.DOM_interactivo : 0}</p>
                 </div>
               </div>
               <br></br>
               <h2 className='title-sections-cards-times'>Tiempos Totales</h2>
               <div className='sections-panels-perf-total'>
                 <div className='sections-panels-perft-g1'>
                   <p>DOM Completo</p>
                   <p className='sect-pan-perfitemstrong'>{timingMetrics?.DOM_completo ? timingMetrics?.DOM_completo : 0}</p>
                   <div className='line-gold-panels'></div>
                 </div>
                 <div className='sections-panels-perft-g2'>
                   <p>Carga Total de Página</p>
                   <p className='sect-pan-perfitemstrong'>{timingMetrics?.Carga_total_de_página ? timingMetrics?.Carga_total_de_página : 0}</p>
                   <div className='line-gold-panels'></div>
                 </div>
 
               </div>
               
 
           </div>
         </>:
         <>
           <div className="progress-container">
             <div className="progress-bar" style={{ width: `${progress}%` }} />
           </div>
           <p className="progress-message">{message}</p>
         </>
         }
         </div>
      </>
       
      );
    };
    
    